import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

import FormLabel from '@material-ui/core/FormLabel'

import GridItemCondense from 'components/Grid/GridItemCondense.jsx'
// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles'

// general api
import { insertOne, updateOne,retrieveDataUsingGraphQL } from '../../services/generalServiceAPI'
import { jsonPP, noError, handleResponseOfSaving, logger } from '../utility/utility'
import swal from 'sweetalert'

import { GeneralData } from 'staticConfig.js'
import NumberFormat from 'react-number-format'

const getExchangeRates = `
query ExchangeRates {
  exchangeRates {
    id
    cad
    cny
    eur
  }
}
`
class ExRates extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        title: 'Exchange Rates',
        button: 'Save'
      },
      data: {
        tableName: 'exchangeRates',
        id:'',
        cad: 1.0000,
        hk:1.0000,
        cny: 1.0000,
        eur:1.0000
      },
      dataState: {
        cad: '',
        hk: ''
      },
      dirty: false
    }

    this.save = this.save.bind(this)
    this.change = this.change.bind(this)
  }

  change(event) {
    this.setState({
      data: { ...this.state.data, [event.target.id]: parseFloat(event.target.value) }
    })
    if (!this.state.dirty) this.setState({ dirty: true })
  }

  save() {

    if (this.state.dirty) {
      if (noError(this.state.dataState)) {
        const insertOrModify = data => (data.id !== '' ? updateOne(data) : insertOne(data))
        const { tableName, ...rest } = this.state.data
        insertOrModify({ tableName, ...rest })
          .then(response => {
            return response.json()
          })
          .then((res) => {
            
            return  this.setState({
              dirty: false,
              data: {
              ...this.state.data,
              id: res.id
              }
            } )
           } )
          .catch(e => swal(`General api throw error: ${e}`))
      } else swal('Please fix the error on the page first.')
    }

  }
  componentDidMount() {
    retrieveDataUsingGraphQL(getExchangeRates)
    .then((response) => {
      if (response.ok) {
        console.log(response)
        return response.json()
      } else {
        logger('[exchangeRates][componentDidMount][1]:', { response }, true)
      }
    })
    .then(({ data }) => {
      const { exchangeRates } = data
      logger('[exchangeRates][componentDidMount][2]:', { data }, true)
      this.setState({ data: {
        ...this.state.data,
        ...exchangeRates
        // cad: !exchangeRates.cad  ? 1.0000: exchangeRates.cad,
        // hk: !exchangeRates.hk  ? 1.0000: exchangeRates.hk
      } })
    })
    .catch((error) => logger('[Dashboard][componentDidMount][3]:', error, true))
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={8} md={6}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {this.state.text.title} <small />
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  {/**   name*/}
                  <GridContainer>
                    <GridItem xs={2}>
                     <CustomInput labelText="USD/CAD" inputProps={{disabled:true,value:''}}  />
                    </GridItem>                   
                    <GridItem xs={10} >
                      <CustomInput
                        success={this.state.dataState.cad === 'success'}
                        error={this.state.dataState.cad === 'error'}
                        id="cad"
                        inputProps={{
                          disabled: false,
                          value: this.state.data.cad,
                          onChange: event => this.change(event),
                          type: 'number'
                        }}
                      />
                    </GridItem>

                    <GridItem xs={2}>
                     <CustomInput labelText="USD/EUR" inputProps={{disabled:true,value:''}}  />
                    </GridItem>   
                    <GridItem xs={10}>
                      <CustomInput
                        success={this.state.dataState.eur === 'success'}
                        error={this.state.dataState.eur === 'error'}
                        id="eur"
                        inputProps={{
                          disabled: false,
                          value: this.state.data.eur,
                          onChange: event => this.change(event),
                          type: 'number'
                        }}
                      />
                    </GridItem>
                    <GridItem xs={2}>
                     <CustomInput labelText="USD/CNY" inputProps={{disabled:true,value:''}}  />
                    </GridItem>   
                    <GridItem xs={10}>
                      <CustomInput
                        success={this.state.dataState.cny === 'success'}
                        error={this.state.dataState.cny === 'error'}
                        id="cny"
                        inputProps={{
                          disabled: false,
                          value: this.state.data.cny,
                          onChange: event => this.change(event),
                          type: 'number'
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button color="rose" className={classes.updateProfileButton} onClick={this.save}>
                    {this.state.text.button}
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {jsonPP(this.state)}
      </div>
    )

  }
}

export default withStyles(styles)(ExRates)
